export const MelayuMenCostList = [
  {
    name: "Baju Melayu Cekak Musang",
    img_src: "https://66.media.tumblr.com/2370a44afffd95bd7cc12cd739ba4712/c0f7a0a2a0e79625-af/s540x810/e1df3460d503de2ed05ff528d37680fb3af0a82a.png",
    sub_img: "https://66.media.tumblr.com/2370a44afffd95bd7cc12cd739ba4712/c0f7a0a2a0e79625-af/s540x810/e1df3460d503de2ed05ff528d37680fb3af0a82a.png",
    description: "Baju Melayu Cekak Musang is a traditional costume for Malay men. It has a collar and 5 buttons. Some people say it as a symbol household harmony. The Baju Melayu used to be reserved for special occasions and during Eid celebrations. Today, however, it is very common to see Baju Melayu worn at school on Fridays by students and teachers alike.",
    url: "Baju-Melayu-Cekak-Musang"
  },

  {
    name: "Kain Pelikat",
    img_src: "https://66.media.tumblr.com/92f0909df85eab40cfb6104465829b8d/c0f7a0a2a0e79625-2e/s540x810/e2690b60968cec4133a60cbda5d5f983c907697a.png",
    sub_img: "https://66.media.tumblr.com/92f0909df85eab40cfb6104465829b8d/c0f7a0a2a0e79625-2e/s540x810/e2690b60968cec4133a60cbda5d5f983c907697a.png",
    description: "TThe Kain Pelikat functions as a sarong for men. It was said that men used to use it as rags when performing the hajj as they were not allowed to wear sewn clothes in ‘ihram’. a sacred state which a Muslim must enter in order to perform the pilgrimage.",
    url: "Kain-Pelikat"
  },

  {
    name: "Songkok",
    img_src: "https://66.media.tumblr.com/45d5b23e523c6066d203577545e44ec1/c0f7a0a2a0e79625-93/s540x810/226dc902f8af97a563ff5f913e89f1b345e4f430.png",
    sub_img: "https://66.media.tumblr.com/45d5b23e523c6066d203577545e44ec1/c0f7a0a2a0e79625-93/s540x810/226dc902f8af97a563ff5f913e89f1b345e4f430.png",
    description: "The Songkok functions as a cap.  It is used to cover mens head and was usually worn during official events. But nowadays, even students in school are seen to be wearing Songkok. ",
    url: "Songkok"
  },

  {
    name: "Seluar Sumbu",
    img_src: "",
    sub_img: "",
    description: "Seluar Sumbu is a type of pants with no waistband therefore would require the wearer to tie the pants up with a separate band attached. ",
    url: "Seluar-Sumbu"
  },

];

export const MelayuWomenCostList = [
  {
    name: "Baju Kurung",
    img_src: "https://66.media.tumblr.com/da6f056cab0935f4724476a9f5c824dc/c0f7a0a2a0e79625-1f/s400x600/586f58b13402a983e9b45b3f8f924871edaee3bb.png",
    sub_img: "https://66.media.tumblr.com/da6f056cab0935f4724476a9f5c824dc/c0f7a0a2a0e79625-1f/s400x600/586f58b13402a983e9b45b3f8f924871edaee3bb.png",
    description: "Baju Kurung has its own design. It is used during weddings or Hari Raya celebrations. It is not tailored to be body-fitted. The materials used to make the traditional baju kurung is usually not too thick and not too thin i.e. cotton or silk or songket.",
    url: "Baju-Kurung"
  },

  {
    name: "Tudung Keringkam",
    img_src: "https://66.media.tumblr.com/9ed1fc3862b498092f7eac65860470db/c0f7a0a2a0e79625-0a/s540x810/fe8c97aa6f4258c7d1668947adb4eeac8ca71a12.png",
    sub_img: "https://66.media.tumblr.com/9ed1fc3862b498092f7eac65860470db/c0f7a0a2a0e79625-0a/s540x810/fe8c97aa6f4258c7d1668947adb4eeac8ca71a12.png",
    description: "The Tudung Keringkam is a traditional scarf worn by Sarawak Malay women during special occasions such as weddings and festivals. The floral embroidery on the cloth is usually embroidered with gold or silver thread. It is a priceless Malay clothing artefact with high value in price and tradition. The Tudung Keringkam is usually a family heirloom passed from generation to generation. ",
    url: "Tudung-Keringkam"
  },

  {
    name: "Kain Batik",
    img_src: "https://66.media.tumblr.com/48407e7fd0e74118f2f433cbb3847c77/c0f7a0a2a0e79625-35/s540x810/ee09d25858e2fb84d9348f9d7adfe254b6783ebd.png",
    sub_img: "https://66.media.tumblr.com/48407e7fd0e74118f2f433cbb3847c77/c0f7a0a2a0e79625-35/s540x810/ee09d25858e2fb84d9348f9d7adfe254b6783ebd.png",
    description: "In the olden days, the Malays would be seen wearing Kain Batik at home whether as a sarong or as a piece of clothing and the older would would use the Kain Batik as head-covers. The pattern is made from metal or wooden patten blocks. This is why the traditional Kain Batik has its own specific and repetitive design patterns.",
    url: "Kain-Batik"
  },

  {
    name: "Baju Kebaya",
    img_src: "",
    sub_img: "",
    url: "Baju-Kebaya"
  },

];
